
import { Payload } from "@/types/profile";

export const applicationsPayloads: Payload[] = [
  // App Lock payloads
  {
    id: "appLock",
    name: "App Lock",
    description: "Configure App Lock settings",
    category: "Applications",
    supportedPlatforms: ["ios", "ipados"],
    configFields: [
      {
        id: "appBundleID",
        name: "App Bundle ID",
        type: "text",
        required: true,
        description: "The bundle ID of the app to lock to"
      },
      {
        id: "disableTouch",
        name: "Disable Touch",
        type: "boolean",
        required: false,
        default: false,
        description: "Disable touch input"
      },
      {
        id: "disableDeviceRotation",
        name: "Disable Device Rotation",
        type: "boolean",
        required: false,
        default: false,
        description: "Disable device rotation"
      }
    ]
  }
];
